import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import dateFns from '@date-io/date-fns'

import es from 'date-fns/locale/es'

export const FormDateProvider = props => (
  <MuiPickersUtilsProvider locale={es} utils={dateFns} {...props} />
)
